import OnboardingPage from "@/pages/Onboarding/OnboardingPage";
import { createFileRoute } from "@tanstack/react-router";
import { requireFirstTimeOnboarding } from "@/utils/routeGuards";

/**
 * Route for starting onboarding without a company.
 * The onboarding flow will create a company during the process.
 */
export const Route = createFileRoute("/app/onboarding")({
  validateSearch: (search: Record<string, unknown>): { new?: boolean } => ({
    new: search.new === true || search.new === "true" ? true : undefined,
  }),
  beforeLoad: async ({ search }) => {
    await requireFirstTimeOnboarding({ allowNewCompany: search.new === true });
  },
  component: OnboardingPage,
});
